export default {
  ORDER: "Order",
  ORDERS: "Orders",
};
